import { render, staticRenderFns } from "./QuestionnaireDetail.vue?vue&type=template&id=b722e2e2&"
import script from "./QuestionnaireDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports